import { motion } from "framer-motion";

export const PageHeader = ({ kicker, title, subtitle, children }) => (
  <section className="pt-36 pb-16 md:pt-44 md:pb-20 px-6 md:px-10 lg:px-14 border-b border-white/5 relative overflow-hidden">
    <div className="absolute -top-1/2 -right-1/2 w-full h-full bg-[#FFC300] opacity-[0.04] blur-3xl rounded-full pointer-events-none"></div>
    <div className="relative">
      {kicker && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="tag-label mb-5 flex items-center gap-3"
          data-testid="page-kicker"
        >
          <span className="w-10 h-px bg-[#FFC300]"></span>
          <span>{kicker}</span>
        </motion.div>
      )}
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="font-display text-[2.4rem] sm:text-5xl md:text-6xl lg:text-8xl uppercase tracking-tighter leading-[0.95] sm:leading-[0.9] max-w-5xl break-words hyphens-auto"
        data-testid="page-title"
        style={{ wordBreak: "break-word", overflowWrap: "anywhere" }}
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-8 max-w-2xl text-lg md:text-xl text-zinc-300 leading-relaxed"
          data-testid="page-subtitle"
        >
          {subtitle}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
